
// src/reducers/sub-diaries-reducer.js

import { mergeArray, deleteArray, getArray, updateArray } from '../helpers/store'
import map from 'lodash/map'

import {
  FETCH_SUB_DIARIES,
  FETCH_SUB_DIARIES_REQUESTED,
  FETCH_SUB_DIARIES_COMPLETED,
  FETCH_SUB_DIARIES_FAILED,
  FETCH_SUB_DIARY,
  FETCH_SUB_DIARY_REQUESTED,
  FETCH_SUB_DIARY_COMPLETED,
  FETCH_SUB_DIARY_FAILED,
  SEARCH_DIARIES,
  SEARCH_DIARIES_REQUESTED,
  SEARCH_DIARIES_COMPLETED,
  SEARCH_DIARIES_FAILED,
  CLEAR_SUB_DIARIES,
  LOAD_DIARY_TO_SUB_DIARIES,
} from '../actions/sub-diaries'

import {
  FETCH_HOME_SUB_DIARIES,
  FETCH_HOME_SUB_DIARIES_REQUESTED,
  FETCH_HOME_SUB_DIARIES_COMPLETED,
  FETCH_HOME_SUB_DIARIES_FAILED,
  FETCH_HOME_SUB_USER_DIARIES,
  FETCH_HOME_SUB_USER_DIARIES_REQUESTED,
  FETCH_HOME_SUB_USER_DIARIES_COMPLETED,
  FETCH_HOME_SUB_USER_DIARIES_FAILED,
  SEARCH_HOME_DIARIES,
  SEARCH_HOME_DIARIES_REQUESTED,
  SEARCH_HOME_DIARIES_COMPLETED,
  SEARCH_HOME_DIARIES_FAILED,
} from '../actions/home-sub-diaries'

import {
  MARK_DIARY_READ_COMPLETED,
  DELETE_DIARY_COMPLETED,
  LOAD_DIARY,
} from '../actions/diaries'

import {
  POST_COMMENT_COMPLETED,
  PUT_COMMENT_COMPLETED,
  DELETE_COMMENT_COMPLETED,
} from '../actions/comments'

import {
  LIKE_DIARY_COMPLETED,
  LIKE_COMMENT_COMPLETED,
  DELETE_LIKE_COMPLETED,
} from '../actions/likes'

import {
  TRANSLATE_DIARY_COMPLETED,
  TRANSLATE_COMMENT_COMPLETED,
} from '../actions/translate'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  hasMore: true,
  items: undefined,
}

function updateGroup(groups, group_id, group) {
  let _group = Object.assign({}, groups[group_id], group)
  return Object.assign({}, groups, { [group_id]: _group })
}

export default function subDiariesReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_SUB_DIARIES_REQUESTED:
  case SEARCH_DIARIES_REQUESTED:
  case FETCH_HOME_SUB_DIARIES_REQUESTED:
  case FETCH_HOME_SUB_USER_DIARIES_REQUESTED:
  case SEARCH_HOME_DIARIES_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
      hasMore: true,
    })

  case FETCH_SUB_DIARY_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_SUB_DIARIES_FAILED:
  case SEARCH_DIARIES_FAILED:
  case FETCH_HOME_SUB_DIARIES_FAILED:
  case FETCH_HOME_SUB_USER_DIARIES_FAILED:
  case SEARCH_HOME_DIARIES_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case FETCH_SUB_DIARY_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case FETCH_SUB_DIARIES_COMPLETED:
  case SEARCH_DIARIES_COMPLETED:
  case FETCH_HOME_SUB_DIARIES_COMPLETED:
  case FETCH_HOME_SUB_USER_DIARIES_COMPLETED:
  case SEARCH_HOME_DIARIES_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: action.offset > 0 ? mergeArray('diary_id', state.items, action.results) : action.results,
      hasMore: action.results.length == 10,
    })

  case LOAD_DIARY_TO_SUB_DIARIES:
    return Object.assign({}, state, {
      items: [action.diary],
      hasMore: false
    })

  case FETCH_SUB_DIARY_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: mergeArray('diary_id', state.items, [action.results], 'append')
    })

  case MARK_DIARY_READ_COMPLETED:
  case POST_COMMENT_COMPLETED:
  case PUT_COMMENT_COMPLETED:
  case DELETE_COMMENT_COMPLETED:
  case LIKE_DIARY_COMPLETED:
  case LIKE_COMMENT_COMPLETED:
  case DELETE_LIKE_COMPLETED:
    let original_items = Object.assign([], state.items)
    let target_items =  [action.results]
    
    target_items.forEach(target_item => {
      
      let index = original_items.findIndex(orig_elm => orig_elm['diary_id'] === target_item['diary_id']);
      if (index >= 0) {
          // Add the 'group' from the original diary to the fetched diary
          target_item.group = original_items[index].group;
      }
  });

    return Object.assign({}, state, {
      items: mergeArray('diary_id', state.items, target_items, 'discard')
    })

  case LOAD_DIARY:
    if (action.deleted) {
      return Object.assign({}, state, {
        items: deleteArray('diary_id', state.items, action.diary.diary_id)
      })
    }
    return Object.assign({}, state, {
      items: mergeArray('diary_id', state.items, [action.diary], 'discard')
    })

  case DELETE_DIARY_COMPLETED:
    return Object.assign({}, state, {
      items: deleteArray('diary_id', state.items, action.results.diary_id)
    })

  case CLEAR_SUB_DIARIES:
    return initialState

  case TRANSLATE_DIARY_COMPLETED:
    return Object.assign({}, state, {
      items: updateArray('diary_id', state.items, action.diary_id, 'attach_json', action.results.attach_json),
    })

  case TRANSLATE_COMMENT_COMPLETED:
    let diary = getArray('diary_id', state.items, action.diary_id)
    if (!diary) return state
    let comments = diary.comments && map(diary.comments, (comment)=> {
      if (comment.comment_id == action.comment_id)
        return Object.assign({}, comment, { attach_json: action.results.attach_json })
      else {
        let sub_comments = comment.comments && map(comment.comments, (sub_comment)=> {
          if (sub_comment.comment_id == action.comment_id)
            return Object.assign({}, sub_comment, { attach_json: action.results.attach_json })
          else
            return sub_comment
        }) || undefined
        return Object.assign({}, comment, { comments: sub_comments })
      }
    }) || undefined
    return Object.assign({}, state, {
      items: updateArray('diary_id', state.items, action.diary_id, 'comments', comments),
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sub-diaries-reducer.js